import React from 'react';

/**
 * Serie de luces navideñas como banda bajo la cintilla de la cabecera. Solo CSS: los
 * focos parpadean con `@keyframes`, el cable son bordes redondeados. Bastan más
 * focos de los que caben: la banda recorta el sobrante y se escala con la cintilla.
 */
const BULBS = 60;

const LightRope: React.FC = () => (
  <ul className="lightrope" aria-hidden="true">
    {Array.from({ length: BULBS }, (_, i) => (
      <li key={i} />
    ))}
  </ul>
);

export default LightRope;
